/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsDownloadAll200,
  GetApiV1PersonIdAttachmentsDownloadAll204,
  GetApiV1PersonIdAttachmentsDownloadAll401,
  GetApiV1PersonIdAttachmentsDownloadAll404,
  GetApiV1PersonIdAttachmentsDownloadAll500,
  GetApiV1PersonIdAttachmentsDownloadAllPathParams,
  GetApiV1PersonIdAttachmentsDownloadAllQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsDownloadAll.ts";

export const getApiV1PersonIdAttachmentsDownloadAllPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAllPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsDownloadAll200Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAll200>;

/**
 * @description Nenhum arquivo disponível no storage
 */
export const getApiV1PersonIdAttachmentsDownloadAll204Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAll204>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsDownloadAll401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAll401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAttachmentsDownloadAll404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAll404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsDownloadAll500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAll500>;

export const getApiV1PersonIdAttachmentsDownloadAllQueryResponseSchema =
  z.union([
    z.lazy(() => getApiV1PersonIdAttachmentsDownloadAll200Schema),
    z.lazy(() => getApiV1PersonIdAttachmentsDownloadAll204Schema),
  ]) as unknown as ToZod<GetApiV1PersonIdAttachmentsDownloadAllQueryResponse>;
